import React, { useState } from 'react';
import { useCompaniesData } from '../../../../../Hooks/TT_ELD/Companies';
import CompaniesTable from './CompaniesTable';
import { Button } from 'antd';
import SearchInput from '../../../../../Utils/SearchInput';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import SearchOptions from '../../../../../Utils/SearchOptions';
import { SearchForOwnerDispatchers } from '../../../../../Utils/SearchResults';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';

const DisputedCompanies = () => {
  const [company, setCompany] = useRouteQuery('', 'company', (v) => String(v));
  const [usdot, setUsdot] = useRouteQuery('', 'usdot', (v) => String(v));
  const [uid, setUid] = useRouteQuery('', 'uid', (v) => String(v));
  const [ownerId, setOwnerId] = useState('');
  const [isDispute, setiSDispute] = useState<string>('true');

  useTagQuerySync(
    { en_US: 'Disputed Companies', zh_CN: '' }, // label
    'disputed-companies', // code
    { company, usdot, uid }, // queryParams
    {
      company: setCompany,
      usdot: setUsdot,
      uid: setUid,
    }, // setFunctions
  );

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      company: setCompany,
      usdot: setUsdot,
      uid: setUid,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip('1');
    }
  };
  const [skip, setSkip] = useState<string>('1');
  const { data, refetch, isLoading, isFetching } = useCompaniesData(
    company,
    usdot,
    undefined,
    skip,
    '',
    ownerId,
    isDispute,
    uid,
  );
  const onChange = (query: any) => {
    setSkip(query.current);
  };
  return (
    <div className="mainPage">
      <SearchInput
        value={company}
        placeholder="Search by company"
        onDebounceChange={(event: string) => handleChange(event, 'company')}
      />
      <SearchInput
        value={usdot}
        placeholder="Search by USDOT"
        onDebounceChange={(event: string) => handleChange(event, 'usdot')}
      />
      <SearchOptions
        SearchResult={SearchForOwnerDispatchers}
        onSelect={(value: any, { valId }: { valId: any }) => {
          setOwnerId(valId);
          if (valId) setSkip('1');
        }}
        placeholder="Search by owner"
      />
      <SearchInput
        value={uid}
        placeholder="Search by UID"
        onDebounceChange={(event: string) => handleChange(event, 'uid')}
      />

      <Button
        style={{ float: 'right', marginLeft: '15px' }}
        size={'large'}
        onClick={() => refetch()}
      >
        Refresh
      </Button>
      <CompaniesTable
        companiesData={data?.data}
        total={data?.count}
        onChange={onChange}
        isLoading={isLoading}
        isFetching={isFetching}
        skip={skip}
        refetch={refetch}
      />
    </div>
  );
};

export default DisputedCompanies;
